import { IButtonProperties } from '@vfde-brix/ws10/button';
import {
    getCMSConfig,
    getLoginCtaCmsProps,
} from '../cms';
import { Customer } from '@vfde-sails/login';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Gets the properties for a button component
 */
export const getSummaryCardUpdatedButtonProps = (
    customer?: Customer,
    onClick?: () => void,
): Partial<IButtonProperties> => {
    const { login, loggedInDsl, loggedInCableOrMobile } = getCMSConfig().offerSummaryCard.button;
    const { text, link } = !customer
        ? getLoginCtaCmsProps(login)
        : customer.hasDslContract
            ? loggedInDsl
            : loggedInCableOrMobile;

    return {
        stdContent: text,
        linkHref: link,
        business: onClick ? { onClick } : NO_PATTERN_BUSINESS_LOGIC,
    };
};
